// src/pages/BlogDetail.js
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from './BlogDetail.module.css';

const BlogDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
        const response = await fetch(`${API_URL}/api/blog/${id}/`, {
          headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) throw new Error('Post not found');

        const data = await response.json();
        setPost(data);
      } catch (error) {
        console.error('❌ Detail Fetch Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
    window.scrollTo(0, 0);
  }, [id]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner} />
      </div>
    );
  }

  if (!post) {
    return (
      <div className={styles.notFound}>
        <h2>Article not found</h2>
        <Link to="/blog" className={styles.backLink}>Return to Knowledge Hub</Link>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{post.title} | Nulek Consulting Blog</title>
        <meta name="description" content={post.excerpt || post.content.substring(0, 160)} />
      </Helmet>

      {/* Article Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <Link to="/blog" className={styles.backToBlog}>
            ← BACK TO BLOG
          </Link>
          <h1 className={styles.title}>{post.title}</h1>
          <div className={styles.meta}>
            Published on {new Date(post.published_at).toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' })}
          </div>
        </div>
      </header>

      
      {/* Featured Image */}
      <div className={styles.imageWrapper}>
        <img
          src={
            post.image ||
            `${process.env.PUBLIC_URL}/img/img${String(
              ((Number(post.id) - 1) % 5) + 1
            ).padStart(2, '0')}.jpeg`
          }
          alt={post.title}
          className={styles.featuredImage}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = `${process.env.PUBLIC_URL}/img/img01.jpeg`;
          }}
        />
      </div>


      {/* Content Section */}
      <article className={styles.article}>
        <div className={styles.content}>
          {post.content}
        </div>

        {/* Bottom Navigation */}
        <div className={styles.cta}>
          <h4>Interested in specialized project planning?</h4>
          <Link to="/contact" className={styles.ctaButton}>
            Work with Nulek Consulting
          </Link>
        </div>
      </article>
    </div>
  );
};

export default BlogDetail;